import { Component } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { LocationResponse } from '../../../../types';

type CellParams = ICellRendererParams<LocationResponse> & {
  addCallback: () => void;
};

@Component({
  selector: 'app-pan-cell-locations-list-header',
  imports: [UiModule, MatTooltipModule, RouterModule, MatMenuModule, SweetAlert2Module],
  templateUrl: './cell-locations-list-header.component.html',
  styleUrl: './cell-locations-list-header.component.scss',
})
export class CellLocationsListHeaderComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
